// clearFilters — VQE-Edit edit-action: drop the WHOLE WHERE / HAVING clause
// (every fragment + the leading keyword) in ONE commit, so the "Clear all"
// action (report G6) is a single Monaco undo stop regardless of how many
// fragments the clause holds — unlike calling `removeFilter` once per
// fragment, which would push one undo stop per call.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/modify/remove
// filter (WHERE / HAVING).

import type { BooleanClauseTarget } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx, type CommitOutcome } from '../commitEdit';

export type ClearFiltersOptions = {
  /** Target clause — `'where'` (default) or `'having'`. */
  readonly clause?: BooleanClauseTarget;
};

export async function clearFilters(
  ctx: CommitEditCtx,
  options: ClearFiltersOptions = {},
): Promise<CommitOutcome> {
  const clause = options.clause ?? 'where';
  return commitEdit({ op: clause === 'having' ? 'clear-having' : 'clear-where' }, ctx);
}
